export const testSampleTypeOptions = [
  { value: "Nasal Swab", label: "Nasal Swab" },
  {
    value: "Saliva Collection Tube",
    label: "Saliva Collection Tube",
  },
  //   { value: "Capillary Blood", label: "Capillary Blood" },
]
